import { useEffect, useState } from "react"
import { NavLink } from "react-router-dom"
import useLogos from "../../hooks/useLogos"
import { getInfoTextService } from "../../services/infoTextService"
import '../../styles/header.css'
import '../../styles/index.css'
import HeaderMenu from "./HeaderMenu"

const Header = () => {

    const { logoCardif } = useLogos()

    const [infoApi, setInfoApi] = useState()

    useEffect(() => {
        try {
            getInfoTextService().then((resp) => {
                setInfoApi(resp.InfoApi)
            })
        } catch (error) {
            console.log(error)
        }
    }, [])

    return (
        <div className="sticky-top">
            <div className="container-fluid header">
                <div className="home__header">
                    <div className="home__logo">
                        <NavLink to={'/'}>
                            {logoCardif}
                        </NavLink>
                    </div>
                    <HeaderMenu infoApi={infoApi} />
                </div>
            </div>
        </div>
    )
}

export default Header